import { colors } from "../Styles";
import { AttentionTypes } from "./valueTypes";

export const CreateAttentionStyles = (t: (key: string) => string, attentionType?: string) => {
  let textColor = "";
  let attentionText = "";
  let attentionColor = "";

  switch (attentionType) {
    case AttentionTypes.good:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.good}`);
      attentionColor = colors.systemGreen;
      break;
    case AttentionTypes.warning:
      textColor = colors.greyDarkPrimary;
      attentionText = t(`systemControls.states.${AttentionTypes.warning}`);
      attentionColor = colors.systemYellow;
      break;
    case AttentionTypes.alert:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.alert}`);
      attentionColor = colors.systemRed;
      break;
    case AttentionTypes.neutral:
    default:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.neutral}`);
      attentionColor = colors.blackPrimary;
      break;
  }

  return { textColor, attentionText, attentionColor };
};
